module.exports = __webpack_public_path__ + "img/ico-home-on-copy.1b0a42c5.svg";